<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <transition name="slidedown">
        <div v-if="crumbsVisible" class="page-crumbs">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <router-link
                :key="`crumb_${crumb.name}`"
                v-for="crumb in $route.meta.crumbs"
                :to="{ name: crumb.name }"
                tag="li"
              >
                <a
                  ><span class="link">{{ crumb.label }}</span></a
                >
              </router-link>
              <li class="is-active">
                <a href="#" aria-current="page">Tour</a>
              </li>
            </ul>
          </nav>
        </div>
      </transition>
      <div class="page">
        <section class="page-section">
          <div class="section-heading">
            <h1>Tours</h1>
          </div>
          <div class="page-section-content" style="font-size: 1.5rem;">
            <p style="margin: 0 .75rem 0 .75rem;">Info o tours</p>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import { format } from "timeago.js";

export default {
  data() {
    return {
      crumbsVisible: true
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    }
  },
  components: {
    Page
  },
  metaInfo: {
    title: "Events"
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}

.bottom-links {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
